import {IAppRoutes} from '@em/shared/util-configuration';

export const AppRoutes: IAppRoutes = {
  home: '/overview',
  login: '/auth/login',
  subscribe: '/payment',
};
